import apiService, { ApiService } from './ApiService';
import { apis } from '../utility/constants';
import { List, ListParams } from '../types/main';
import { transformList } from './transformer';
import { Product } from '../types/products';

class ProductService {
  private route = apis.product;

  constructor(private api: ApiService) {}

  list = (params: ListParams) => this.api
    .get<List<Product>>(this.route.publicList, params)
    .then(transformList);
}

export default new ProductService(apiService);
